import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';

const styles = {
  tableRow: {
    borderBottom: `1px solid ${colors.neutral[300]}`,
    '&:last-of-type': {
      borderBottom: 'none',
    },
  },
  tableCell: {
    font: { size: '1.6rem', lineHeight: '2.4rem' },
    color: colors.neutral[900],
    letterSpacing: '0.02rem',
    padding: '1.6rem 0rem',
    '&:first-child': {
      paddingLeft: '2.4rem',
      paddingRight: '1rem',
      width: '30%',
    },
    '&:last-child': {
      paddingRight: '2.4rem',
      width: '20%',
    },
  },
  expiredLabel: {
    margin: 0,
    color: colors.red[500],
    font: {
      size: '1.2rem',
      lineHeight: '2rem',
      weight: 500,
    },
    textTransform: 'uppercase',
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
